import { DeleteProjetoRevisaoRequest } from "../../../data/daos/delete/delete_projeto_revisao";
import { IDeleteProjetoRevisaoUseCase } from "../../../presentation/useCases/delete/delete_projeto_revisao_use_case";

import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteProjetoRevisaoUseCase
 */

export class DeleteProjetoRevisaoUseCase implements IDeleteProjetoRevisaoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoRevisao(model: DeleteProjetoRevisaoRequest): Promise<void> {
    await this.repository.deleteProjetoRevisao(model);
  }
}
